module.exports = __webpack_public_path__ + "static/media/template.428ed397.svg";